import { fillHeightForMobile } from '@williamhill/rosi-ui-shared/src/global-style';
import { History } from 'history';
import React, { useEffect } from 'react';
import { Route, Router, Switch, RouteComponentProps } from 'react-router-dom';
import styled, { css } from 'styled-components';
import { isSafari } from 'react-device-detect';

import HomeComponent from './home';
import ManualEntryComponent from './manual-entry';
import ScanBetComponent from './scan-bet';
import BetsComponent from './bets';
import useModal from './use-modal';
import { PageToPaths, useTicketSearchNavigation } from './navigation';
import NavigationBar from './navigation-bar';
import { PageToTicketSearchOrigin } from './manual-entry/use-ticket-search-context';

export interface AppProps {
  history: History;
}

export default function App({ history }: AppProps) {
  const { modal, isVisible: isModalVisible } = useModal();

  return (
    <Container>
      <Router {...{ history }}>
        {/** Sub-directory paths aren't supported on local instance. On server they are resolved by redirection:
         * https://gitlab.com/caesarsdigital/usa/infrastructure/terraform/allenvs-multibrand-redirect-retail/-/blob/d9dca5108778e0eb3aba8ad7d196be5ca8449736/src/redirection.py#L241
         */}
        <Content>
          <Switch>
            <Route component={ScanBetComponent} exact path={`/${PageToPaths['Scan']}`} />
            <Route component={ManualEntryComponent} exact path={`/${PageToPaths['TicketEntry']}`} />
            <Route component={BetsComponent} exact path={`/${PageToPaths['Bets']}`} />
            <Route path="/ticket/:retailTicketId" exact component={RedirectToManualEntry} />
            <Route component={HomeComponent} path={`/${PageToPaths['Home']}`} />
          </Switch>
        </Content>
        <NavigationBar />
      </Router>
      {isModalVisible && modal}
    </Container>
  );
}

function RedirectToManualEntry({ match }: RouteComponentProps<{ retailTicketId: string }>) {
  const { goToTicketSearch } = useTicketSearchNavigation();
  useEffect(() => {
    goToTicketSearch({ origin: PageToTicketSearchOrigin['TicketEntry'], ticketNumber: match.params.retailTicketId });
  }, [match.params.retailTicketId]);
  return <HomeComponent />;
}

const Container = styled.div`
  display: grid;
  grid-template-rows: 1fr auto auto;
  max-width: 42rem;
  ${isSafari
    ? fillHeightForMobile
    : css`
        height: 100%;
      `}
  overflow: scroll;
`;

const Content = styled.div`
  overflow: scroll;
`;
